import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

const StyledFooter = styled(Box)(({ theme }) => ({
  background: "var(--overlay-footer)",
  borderRadius: "40px",
  padding: "100px 40px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "calc(100% - 24px)",
  maxWidth: "1200px",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    borderRadius: "20px",
    padding: "20px",
  },
}));

const FooterRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "20px",
  },
}));

const FooterColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

const FooterTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  fontWeight: 600,
  color: "var(--text-black)",
}));

const FooterText = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: "var(--text-secondary)",
  lineHeight: "normal",
}));

const FooterLicense = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  color: "var(--text-secondary)",
  lineHeight: "normal",
  width: "100%",
}));

const FooterPolicy = styled(Link)(({ theme }) => ({
  ...theme.typography.caption,
  fontWeight: 600,
  color: "var(--text-black)",
  lineHeight: "normal",
  width: "100%",
  cursor: "pointer",
}));

export default function Footer() {
  return (
    <StyledFooter>
      <FooterRow>
        <FooterColumn>
          <FooterTitle>Офис</FooterTitle>
          <FooterText>
            Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai,
            U.A.E.
          </FooterText>
        </FooterColumn>
        <FooterColumn>
          <FooterTitle>Контакты</FooterTitle>
          <FooterText>info@gtcpay.io</FooterText>
        </FooterColumn>
      </FooterRow>
      <FooterLicense>
        GTC PAY L.L.C-FZ is registered under license number 2529879.01.
      </FooterLicense>
      <FooterPolicy to="/privacy-policy">
        Пользовательское соглашение
      </FooterPolicy>
    </StyledFooter>
  );
}
